import { dynamicLoadUpgradeQueries } from '../utils';
export const hasUpgradableCyclesQueryFn = async _ref => {
  let {
    httpClient,
    request
  } = _ref;
  if (!request.productId) {
    return {
      hasUpgradableCycles: false
    };
  }
  const {
    fetchUpgradableCycles
  } = await dynamicLoadUpgradeQueries(httpClient);
  const availableCyclesByProductId = await fetchUpgradableCycles({});
  const availableCycles = availableCyclesByProductId == null ? void 0 : availableCyclesByProductId[request.productId];
  return {
    hasUpgradableCycles: Boolean(availableCycles == null ? void 0 : availableCycles.length)
  };
};
//# sourceMappingURL=hasUpgradableCycles.query.js.map